import React from 'react'

const ChannelsIcon = () => {
    return (
        <>
            {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                height={24}
                viewBox="0 -960 960 960"
                width={24}
            >
                <path d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z" fill="#0F3C5B" />
            </svg> */}
            {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={24}
                height={24}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        d="M402 426c-16.753 0-31.124 10.356-37.071 25H330v30h34.929c5.947 14.644 20.318 25 37.071 25 22.056 0 40-17.944 40-40s-17.944-40-40-40zM472 341a39.736 39.736 0 0 0-18.256 4.427l-37.141-30.951A15.003 15.003 0 0 0 407 311h-77v30h71.569l32.565 27.138A39.805 39.805 0 0 0 432 381c0 22.056 17.944 40 40 40s40-17.944 40-40-17.944-40-40-40zM472 216c-16.753 0-31.124 10.356-37.071 25H330v30h104.929c5.947 14.644 20.318 25 37.071 25 22.056 0 40-17.944 40-40s-17.944-40-40-40zM416.603 197.523l37.141-30.951A39.724 39.724 0 0 0 472 171c22.056 0 40-17.944 40-40s-17.944-40-40-40-40 17.944-40 40c0 4.5.758 8.823 2.134 12.862L401.569 171H330v30h77c3.509 0 6.907-1.23 9.603-3.477zM402 86c22.056 0 40-17.944 40-40S424.056 6 402 6c-16.753 0-31.124 10.356-37.071 25H330v30h34.929c5.947 14.644 20.318 25 37.071 25zM150 256c0 57.897 47.103 105 105 105 16.095 0 31.353-3.645 45-10.145v-189.71c-13.647-6.5-28.905-10.145-45-10.145-57.897 0-105 47.103-105 105z"
                        opacity={1}
                        data-original="#000000"
                        className="hovered-path"
                    />
                    <path
                        d="M285 1h-60c-8.284 0-15 6.716-15 15v19.525a225.064 225.064 0 0 0-79.076 32.759l-13.81-13.809c-5.858-5.858-15.355-5.858-21.213 0L53.475 96.901c-5.858 5.857-5.858 15.355 0 21.213l13.809 13.81A225.064 225.064 0 0 0 34.525 211H15c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h19.525a225.076 225.076 0 0 0 32.759 79.077l-13.81 13.81a14.999 14.999 0 0 0 0 21.211l42.427 42.427c5.858 5.858 15.355 5.858 21.213 0l13.81-13.809A225.082 225.082 0 0 0 210 476.475V496c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15V383.278c-14.082 4.994-29.227 7.722-45 7.722-74.439 0-135-60.561-135-135s60.561-135 135-135c15.773 0 30.918 2.728 45 7.722V16c0-8.284-6.716-15-15-15z"
                        opacity={1}
                        data-original="#000000"
                        className="hovered-path"
                    />
                </g>
            </svg> */}
            {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={24}
                height={24}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        d="M171.625 225.757c-8.34 0-15.125 6.785-15.125 15.125v15.175h30.25v-15.175c0-8.34-6.785-15.125-15.125-15.125zM286.1 225.757H271v30.3h15.1c8.354 0 15.15-6.796 15.15-15.149s-6.797-15.151-15.15-15.151z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="m365.824 94.042 19.381-33.917h39.118c6.198 17.529 22.927 30.125 42.552 30.125C491.757 90.25 512 70.007 512 45.125S491.757 0 466.875 0c-19.624 0-36.354 12.596-42.552 30.125h-56.528l-27.997 48.994a194.248 194.248 0 0 0-38.673-13.61V0h-30v60.83a197.689 197.689 0 0 0-30.25 0V0h-30v65.509a194.163 194.163 0 0 0-38.673 13.61l-27.997-48.994H87.677C81.479 12.596 64.749 0 45.125 0 20.243 0 0 20.243 0 45.125S20.243 90.25 45.125 90.25c19.624 0 36.354-12.596 42.552-30.125h39.118l19.381 33.917a197.33 197.33 0 0 0-55.079 56.583H0v30h75.352A194.278 194.278 0 0 0 60.819 241H0v30h60.819a194.277 194.277 0 0 0 14.532 60.375H0v30h91.097a197.342 197.342 0 0 0 55.079 56.583l-19.381 33.917H87.677c-6.198-17.529-22.927-30.125-42.552-30.125C20.243 421.75 0 441.993 0 466.875S20.243 512 45.125 512c19.624 0 36.354-12.596 42.552-30.125h56.528l27.997-48.994a194.248 194.248 0 0 0 38.673 13.61V512h30v-60.83a197.689 197.689 0 0 0 30.25 0V512h30v-65.509a194.163 194.163 0 0 0 38.673-13.61l27.997 48.994h56.528C430.521 499.404 447.251 512 466.875 512 491.757 512 512 491.757 512 466.875s-20.243-45.125-45.125-45.125c-19.624 0-36.354 12.596-42.552 30.125h-39.118l-19.381-33.917a197.33 197.33 0 0 0 55.079-56.583H512v-30h-75.352A194.25 194.25 0 0 0 451.18 271H512v-30h-60.819a194.277 194.277 0 0 0-14.532-60.375H512v-30h-91.097a197.342 197.342 0 0 0-55.079-56.583zM216.75 316.25h-30v-30.193H156.5v30.187h-30v-75.361c0-24.882 20.243-45.125 45.125-45.125S216.75 216 216.75 240.882zm69.35-30.193H271v30.187h-30V195.757h45.1c24.896 0 45.15 20.254 45.15 45.15s-20.255 45.15-45.15 45.15zm94.759 30.193h-30v-120.5h30z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                </g>
            </svg> */}

            {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                version="1.1"
                id="Layer_1"
                width={24}
                height={24}
                x="0px"
                y="0px"
                viewBox="0 0 122.88 122.46"
                style={{ enableBackground: "new 0 0 122.88 122.46" }}
                xmlSpace="preserve"
            >
                <style
                    type="text/css"
                    dangerouslySetInnerHTML={{
                        __html: ".st0{fill-rule:evenodd;clip-rule:evenodd;}"
                    }}
                />
                <g>
                    <path
                        className="st0"
                        d="M69.76,26.16l-7.75,7.75L54.02,42L42.21,53.81l-8.09,7.99l-7.54,7.54c-1.4,1.4-3.68,1.4-5.08,0l-2.95-2.95 c-1.4-1.4-1.4-3.68,0-5.08l43.18-43.18c1.4-1.4,3.68-1.4,5.08,0l2.95,2.95C71.16,22.48,71.16,24.76,69.76,26.16L69.76,26.16z M48.35,26.93L26.93,48.36l-3.18-3.18l21.42-21.42L48.35,26.93L48.35,26.93z M53.12,96.3l7.75-7.75L45.28,72.96 c-2.21-2.21-2.21-5.83,0-8.04l0,0c2.21-2.21,5.83-2.21,8.04,0l15.54,15.54l11.81-11.81L65.13,53.11c-2.21-2.21-2.21-5.83,0-8.04 l0,0c2.21-2.21,5.83-2.21,8.04,0l15.59,15.59l7.54-7.54c1.4-1.4,3.68-1.4,5.08,0l2.95,2.95c1.4,1.4,1.4,3.68,0,5.08l-43.18,43.18 c-1.4,1.4-3.68,1.4-5.08,0l-2.95-2.95C51.72,99.99,51.72,97.7,53.12,96.3L53.12,96.3z M74.48,95.48L95.9,74.06l3.18,3.18 L77.66,98.66L74.48,95.48L74.48,95.48z M63.14,102.33l6.2,6.21c10.79,10.79,20.86,11.28,33.18,1.61l12.31,12.31l8.04-8.04 l-12.41-12.41c9.83-11.93,8.34-23.24-2.11-33.69l-5.6-5.6L63.14,102.33L63.14,102.33z M59.74,20.13l-6.2-6.21 C42.75,3.13,32.67,2.64,20.36,12.31L8.04,0L0,8.04l12.41,12.41c-9.83,11.93-8.34,23.24,2.11,33.69l5.6,5.6L59.74,20.13L59.74,20.13 z"
                    />
                </g>
            </svg> */}

            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={24}
                height={24}
                x={0}
                y={0}
                viewBox="0 0 32 32"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        d="M25 19.75a4.74 4.74 0 0 0 1.78-9.14 5 5 0 0 0-4.49-4.71 7.24 7.24 0 0 0-12.58 0 5 5 0 0 0-4.49 4.71A4.74 4.74 0 0 0 7 19.75h4.25V23a.25.25 0 0 1-.25.25H8.86a2.25 2.25 0 1 0 0 1.5H11A1.76 1.76 0 0 0 12.75 23v-3.25h2.5v5.64a2.25 2.25 0 1 0 1.5 0v-5.64h2.5V23A1.76 1.76 0 0 0 21 24.75h2.14a2.25 2.25 0 1 0 0-1.5H21a.25.25 0 0 1-.25-.25v-3.25z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                </g>
            </svg>

            {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={24}
                height={24}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fillRule="evenodd"
                        d="M26.213 268.456c1.092 16.8 2.929 30.086 7.559 47.224 1.256 4.648 5.328 7.767 10.144 7.767h64.553a10.469 10.469 0 0 0 10.451-11.592c-3.811-36.719-4.22-74.908-1.184-111.948a10.467 10.467 0 0 0-10.472-11.365H43.917c-4.815 0-8.888 3.119-10.144 7.768a225.232 225.232 0 0 0-6.633 35.696c-1.128 10.949-1.254 18.058-1.195 28.869zm98.431-122.198c4.247-23.802 9.946-46.586 16.97-67.861 3.14-9.512-7.701-17.631-15.945-11.942-27.5 18.974-50.698 43.774-67.774 72.602-4.161 7.024.877 15.863 9.041 15.863H114.3c5.137 0 9.442-3.605 10.344-8.662zm227.821-3.888c-7.789-39.304-19.835-75.118-35.54-104.752-1.459-2.753-3.782-4.558-6.811-5.292-35.475-8.594-72.766-8.587-108.216 0-3.029.734-5.351 2.538-6.811 5.292-15.704 29.635-27.75 65.448-35.539 104.752a10.474 10.474 0 0 0 10.307 12.55h172.303c6.657 0 11.601-6.02 10.307-12.55zm45.247 12.55h47.366c8.164 0 13.201-8.838 9.041-15.862-17.077-28.833-40.276-53.64-67.779-72.61-8.244-5.687-19.084 2.432-15.944 11.943 7.024 21.277 12.724 44.063 16.972 67.868.903 5.056 5.208 8.661 10.344 8.661zm5.833 168.528h64.553c4.815 0 8.888-3.118 10.144-7.767a224.9 224.9 0 0 0 6.632-35.697c1.223-11.961 1.193-17.438 1.193-29.33 0-4.765-.771-14.544-1.194-18.648a225.232 225.232 0 0 0-6.633-35.696c-1.255-4.649-5.329-7.768-10.144-7.768H404.75a10.467 10.467 0 0 0-10.472 11.365c3.036 37.041 2.627 75.228-1.184 111.948a10.47 10.47 0 0 0 10.451 11.593zm-18.618 42.016c-5.026 24.486-11.882 48.985-20.606 71.832-3.609 9.45 6.969 18.053 15.485 12.595a231.919 231.919 0 0 0 74.306-76.958c4.162-7.024-.875-15.864-9.04-15.864H395.22c-5.042.001-9.279 3.457-10.293 8.395zM147.69 437.291c-8.724-22.849-15.578-47.34-20.604-71.826-1.014-4.939-5.251-8.395-10.292-8.395H66.942c-8.165 0-13.202 8.84-9.04 15.864a231.957 231.957 0 0 0 74.303 76.952c8.516 5.458 19.094-3.145 15.485-12.595zm191.535-80.221H172.789a10.475 10.475 0 0 0-10.243 12.85c9.451 41.315 23.68 78.181 41.8 107.076 1.595 2.544 3.914 4.141 6.86 4.725 29.576 5.858 60 5.863 89.601 0 2.946-.584 5.264-2.181 6.86-4.725 18.12-28.895 32.35-65.754 41.801-107.076a10.475 10.475 0 0 0-10.243-12.85zM149.353 249.257c0 22.047 1.298 43.797 3.731 64.888a10.469 10.469 0 0 0 10.438 9.303h184.97c5.364 0 9.823-3.975 10.438-9.303a569.291 569.291 0 0 0 1.443-116.04 10.481 10.481 0 0 0-10.465-9.562H162.105a10.481 10.481 0 0 0-10.465 9.562 569.817 569.817 0 0 0-2.287 51.152z"
                        clipRule="evenodd"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                </g>
            </svg> */}



        </>

    )
}

export default ChannelsIcon